import { render, staticRenderFns } from "./CompanyNotificationTemplates.vue?vue&type=template&id=2b6176e6&scoped=true"
import script from "./CompanyNotificationTemplates.vue?vue&type=script&lang=js"
export * from "./CompanyNotificationTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6176e6",
  null
  
)

export default component.exports